'use client';

import React from 'react';

/**
 * Insignia de Seguridad Sectigo Positive SSL para DonWeb.
 * Implementado como componente seguro sin scripts externos que usen `document.write()`,
 * evitando que la página se reinicie o se borre el DOM en React / Next.js.
 */
export function TrustLogoSSL(): React.JSX.Element {
  return (
    <div className="flex flex-col sm:flex-row items-center gap-2 text-[11px] text-slate-400 font-mono py-2">
      <div className="flex items-center space-x-2">
        <a
          href="https://donweb.com/es-ar/certificados-ssl"
          id="comodoTL"
          target="_blank"
          rel="noopener noreferrer"
          title="Certificados SSL Argentina - DonWeb & Sectigo"
          className="group flex items-center space-x-2 bg-slate-900/60 hover:bg-slate-800/80 border border-slate-800 hover:border-emerald-500/40 rounded-md px-2.5 py-1.5 transition-all shadow-sm"
        >
          {/* Sello oficial Sectigo Positive SSL */}
          <img
            src="https://micuenta.donweb.com/img/sectigo_positive_sm.png"
            alt="Sectigo Positive SSL Seal"
            className="h-7 w-auto object-contain transition-transform group-hover:scale-105"
            loading="lazy"
          />
          <div className="flex flex-col text-left">
            <span className="text-[10px] font-bold text-emerald-400 group-hover:text-emerald-300 leading-tight flex items-center gap-1">
              <span>🔒</span> Sitio Protegido SSL
            </span>
            <span className="text-[9px] text-slate-400 group-hover:text-slate-300 leading-tight">
              Sectigo PositiveSSL • 256-bit
            </span>
          </div>
        </a>
      </div>
    </div>
  );
}

